/** @jsx jsx */

import React, { useEffect, useState } from "react";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import MuiSelect from '@material-ui/core/Select/Select';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { jsx, css } from "@emotion/react";
import Button from "@material-ui/core/Button";
import PreviewIcon from '@material-ui/icons/Visibility';
import {
    createTheme,
    ThemeProvider as MuiThemeProvider
} from "@material-ui/core/styles";
import OldVideoCheckerModal from "../Modal/OldVideoCheckerModal";


const onePadding = css`
    padding-top:1em;
    padding-bottom:1em;
`;

const formSelect = css`
    min-width:15%;
`;

const mainDiv = css`
    padding-top:1em;
    display:flex;
`;

const s3InfoDiv = css`
    padding-left:1em;
    padding-right:1em;
    display:flex;
`;

const btnGroup = css`
`;



const themeToplabelSelect = createTheme({
    typography: {
        htmlFontSize: 13,
        fontFamily: ` "Roboto", "游ゴシック体", "Yu Gothic", YuGothic,
      "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", "Meiryo",
      "sans-serif";`,
    },
});

interface LiveSelectionProps {
    clickHandler: (e: string) => void;
    isSelectLiveDisabled: boolean;
    linkVisibility: string;
}

const LiveSelection: React.FC<LiveSelectionProps> = (props) => {

    useEffect(() => {
        console.log("[DEBUG][LiveSelection] useEffect");
    });

    const options = [
        { label: '【擬似ライブ】チャンネル1', value: '1' },
        { label: '【擬似ライブ】チャンネル2', value: '2' },
        { label: '【擬似ライブ】チャンネル3', value: '3' },
        { label: '【擬似ライブ】チャンネル4', value: '4' },
        { label: '【擬似ライブ】チャンネル5', value: '5' }
    ];

    const [selectedOption, setSelectedOption] = useState<String>();
    const [linkText, setLinkText] = useState<String>("");
    const [isModal, setIsModal] = useState<boolean>(false);
    const [uploadedvideoSrc, setUploadedvideoSrc] = useState<string>("");
    const [videoType, setVideoType] = useState<string>("video/mp4");
    const [linkCssValue, setCssLinkValue] = useState<string>("hidden");
    const selectChange = (eventValue: string) => {
        setSelectedOption(eventValue);
        props.clickHandler(eventValue);
        checkS3Link(eventValue);
    };

    const optinalDiv = css`
        flex-grow: 1;
        visibility: ${linkCssValue};
        display: ${props.linkVisibility}
    `;

    const checkS3Link = (e: any) => {
        const s3Key: string = `contents/ch${e}/SourceFile${e}.mp4`;
        function loadLink() {
            const response = fetch("/live/uploader/s3info?s3_key=" + s3Key)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    try {
                        if (data.message.signed_video_url.length > 20) {
                            setLinkText(data.message.signed_video_url);
                            setUploadedvideoSrc(data.message.signed_video_url);
                            setCssLinkValue("visible");
                        } else {
                            setLinkText("");
                            setCssLinkValue("hidden");
                        }
                    } catch (e) {
                        setLinkText("");
                        setCssLinkValue("hidden");
                    }
                })
        }
        loadLink();
    }

    const showPreview = (e: any) => {
        console.log("showPreview");
        setIsModal(true);
    };

    const videoModalCallback = (e: any) => {
        setIsModal(false);
    }

    return (
        <div>
            <h3 css={onePadding} >1.疑似ライブチャンネルの選択</h3>
            <OldVideoCheckerModal uploadedvideoSrc={uploadedvideoSrc} videoType={videoType} clickHandler={videoModalCallback} isModalOpen={isModal}></OldVideoCheckerModal>
            <div>
                <div css={mainDiv}>
                    <FormControl style={{ minWidth: '25%' }} onChange={(e) => { console.log(e) }} >
                        <MuiThemeProvider theme={themeToplabelSelect}>
                            <InputLabel>{"ライブチャンネル"}</InputLabel>
                        </MuiThemeProvider>
                        <MuiSelect
                            autoWidth
                            onChange={(e) => selectChange(e.target.value as string)}
                            defaultValue=""
                            type=""
                            variant='standard'
                            disabled={props.isSelectLiveDisabled}
                        >
                            {options?.map(option => {
                                return (
                                    <MenuItem style={{ fontSize: "1.5rem" }} key={option.value} value={option.value} onChange={(e) => { console.log(e) }}>
                                        {option.label ?? option.value}
                                    </MenuItem>
                                );
                            })}
                        </MuiSelect>
                    </FormControl>
                    <div css={optinalDiv}>
                        <div css={s3InfoDiv}>
                            <div css={btnGroup}>
                                <div>
                                    <Button style={{ marginLeft: "1em" }} size="large" color="default" variant="contained" startIcon={<PreviewIcon />} onClick={(e) => { showPreview(e); }}>
                                        &nbsp;&nbsp;プレビュー&nbsp;&nbsp;&nbsp;
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LiveSelection;

